import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';

class ReadMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      truncated: false,
    };

    this.handleTruncate = this.handleTruncate.bind(this);
    this.toggleLines = this.toggleLines.bind(this);
  }

  handleTruncate(truncated) {
    if (this.state.truncated !== truncated) {
      this.setState({
        truncated,
      });
    }
  }

  toggleLines(event) {
    event.preventDefault();

    this.setState(prevState => ({
      expanded: !prevState.expanded,
    }));
  }

  render() {
    const {
      children, more, less, lines, readMore, width,
    } = this.props;
    const { expanded, truncated } = this.state;

    return (
      <div>
        <Truncate
          lines={!expanded && lines}
          width={width || 0}
          ellipsis={(
            <span>
              ...
              <br />
              {readMore ? (
                <button type="button" className="button--link" onClick={this.toggleLines}>{more}</button>
              ) : null}

            </span>
          )}
          onTruncate={this.handleTruncate}
        >
          {children}
        </Truncate>
        {!truncated && expanded && (
          <span>
            {' '}
            <br />
            {readMore ? (
              <button type="button" className="button--link" onClick={this.toggleLines}>{less}</button>
            ) : null}

          </span>
        )}
      </div>
    );
  }
}

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
  readMore: PropTypes.bool,
  width: PropTypes.number,
};

ReadMore.defaultProps = {
  lines: 7,
  more: 'Read more',
  less: 'Show less',
  readMore: false,
  width: 0,
};


export default ReadMore;
